// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mo-1";
export var spinner = "_mo-0";